import { Module } from 'vuex';
import { DetectionRuleGroupState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: DetectionRuleGroupState = {
    ruleGroups: undefined,
    ruleGroupDetails: {
        ruleGroup: undefined,
        rules: undefined,
    },
    ruleGroupCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    addRules: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    removeRules: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

export const detectionRuleGroup: Module<DetectionRuleGroupState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
